import {Box, HStack, Integer} from 'platform/foundation';
import styled from 'styled-components';

import {ReactNode} from 'react';

import {TestIdProps} from 'shared/web';

interface DataGridTileLayoutProps extends TestIdProps {
  sidePanel: ReactNode;
  children: ReactNode;
}

// Start width of the side panel. It shrinks with the window together with the grid.
const SIDE_PANEL_WIDTH: Integer = 110;

/**
 * A side panel (folder tree or filters) and a data grid as two tiles side by side. The grid needs
 * the CARD wrapper style, whose frame makes it the second tile. The layout fills a parent of
 * definite height, such as `Main isFullHeight`.
 */
export function DataGridTileLayout(props: DataGridTileLayoutProps) {
  return (
    // Size containment keeps the tiles inside the page padding. Without it they grow with the
    // grid, which measures its height from the window bottom.
    <Box height="100%" contain="size">
      <HStack height="100%" spacing={4} data-testid={props['data-testid']}>
        <Box width={SIDE_PANEL_WIDTH} height="100%">
          <SidePanelFrame>{props.sidePanel}</SidePanelFrame>
        </Box>
        <Box width="100%" height="100%">
          {props.children}
        </Box>
      </HStack>
    </Box>
  );
}

// Copies the EagGrid CARD frame (`bg-white border border-slate-200 shadow-sm rounded` in eag-grid
// getWrapperClassName), so both tiles look the same: the theme tokens differ from these Tailwind
// values, and DMS lint forbids className. The border falls back to the theme separator colour if
// the Tailwind variable is missing. No overflow clipping, because select menus in the panel open
// inline and would be cut off at the frame.
const SidePanelFrame = styled.div`
  height: 100%;
  background-color: ${({theme}) => theme.colors.general.white};
  border: 1px solid var(--color-slate-200, ${({theme}) => theme.colors.general.separator});
  border-radius: ${({theme}) => theme.radii.small};
  box-shadow:
    0 1px 3px 0 rgb(0 0 0 / 0.1),
    0 1px 2px -1px rgb(0 0 0 / 0.1);
`;
